module.exports = __webpack_public_path__ + "static/media/131.57328f33.jpg";